export const SUPER_ADMIN = 'SUPER_ADMIN';
